'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = require('./Cookies');

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/universal-cookie/lib/index.js
// module id = 535
// module chunks = 0